import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Cleans technique names by removing "(e.g)" and related text
 * @param techniqueName - The raw technique name from database
 * @returns Cleaned technique name for display
 */
export function cleanTechniqueName(techniqueName: string): string {
  if (!techniqueName) return techniqueName;
  
  // Remove "(e.g., ...)" and everything after it
  return techniqueName.replace(/\s*\(e\.g\.,[^)]*\)/gi, '').trim();
}
